// extracted by mini-css-extract-plugin
export var dropdownButton = "_2x-0";
export var fullWidthDropdownButton = "_2x-1";
export var icon = "_2x-3";
export var iconPlaceholder = "_2x-2";
export var menuItemRow = "_2x-9";
export var separator = "_2x-e";
export var shortcutContainer = "_2x-7";
export var shortcutContainerFilled = "_2x-8";
export var shortcutIconLg = "_2x-6";
export var shortcutIconMd = "_2x-5";
export var shortcutIconSm = "_2x-4";
export var submenuChevron = "_2x-d";
export var submenuDropdown = "_2x-a";
export var submenuTriggerRow = "_2x-b";
export var submenuTriggerRowOpen = "_2x-c";